import * as React from 'react';
import Paper from '@mui/material/Paper';
import { Stack, } from '@mui/system';
import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import FormControl from '@mui/material/FormControl';

import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import io from 'socket.io-client';
import "./price_filter.css"



//Slider props
function valuetext(value) {
  return `${value}`;
}

function ValueLabelComponent(props) {
  const { children, value } = props;

  return (
    <Tooltip enterTouchDelay={0} placement="bottom" title={value}>
      {children}
    </Tooltip>
  );
}

ValueLabelComponent.propTypes = {
  children: PropTypes.element.isRequired,
  value: PropTypes.number.isRequired,
};

//Slider styling
const FilterSlider = styled(Slider)(({ theme }) => ({
  color: theme.palette.mode === 'dark' ? '#3880ff' : '#3880ff',
  height: 2,
  padding: '0px 0',
  '& .MuiSlider-thumb': {
    height: 15,
    width: 15,
    backgroundColor: 'white',
    border: "2px solid black",
    transition: '0.3s',
    boxShadow:"none",

    '&:hover': {
      backgroundColor: "black",
      boxShadow:"none",
    },


  },
  '& .MuiSlider-valueLabel': {
    fontSize: 15,
    fontWeight: 'normal',
    top: 50,
    backgroundColor: 'unset',
    color: theme.palette.text.primary,
    '&:before': {
      display: 'none',
    },
    '& *': {
      background: 'transparent',
      color: theme.palette.mode === 'dark' ? '#fff' : '#000',
    },
  },
  '& .MuiSlider-track': {
    border: 'none',
  },
  '& .MuiSlider-rail': {
    opacity: 0.5,
    backgroundColor: '#bfbfbf',
  },
  '& .MuiSlider-mark': {
    backgroundColor: 'black',
    height: 8,
    width: 1,
    '&.MuiSlider-markActive': {
      opacity: 1,
      backgroundColor: 'black',
    },
  },
}));

//textfield styling
const CssTextField = styled(TextField)({
  '& label.Mui-focused': {
    color: 'black',
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: 'black',
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: 'black',
    },
    '&:hover fieldset': {
      borderColor: 'black',
    },
    '&.Mui-focused fieldset': {
      borderColor: 'black',
    },
  },
});

//Filter component
export default function PriceFilter({ min_price, max_price, lang_id }) {


  const [priceRangeValue, setPriceRangeValue] = React.useState([min_price, max_price]);
  const handleChange = (event, newValue) => {
    setPriceRangeValue(newValue);


  };

  
  // send message to the chat
  const SendMessage = (payload) => {
    let socket_url = process.env.REACT_APP_SOCKET_URL;

    var conversation_id = JSON.parse(window.sessionStorage.chat_session).session_id;
    console.log(conversation_id);
    let socket = io(socket_url);

    socket.on('connect', () => {
      console.log("Connected to Socket.io server");
    });



    socket.emit('user_uttered',
      { "session_id": conversation_id, "message": payload }
    );

  }
  const handleClick = () => {
    // Perform the function to send min and max values somewhere else


    SendMessage(`/inform{"min_rent":"${priceRangeValue[0]}", "max_rent":"${priceRangeValue[1]}"}`);
    console.log("Sending values:");
  };


  return (
    <>


      <Stack spacing={3} >
        <Paper sx={{ width: '70%', height: '320px', mb: 10 ,    "@media screen and (max-width: 768px)": {
          width: '90vw', height: '350px'
          }}}>
          <Stack spacing={5} >

            <Typography sx={{ fontFamily: 'verdana', mt: 3, ml: 3 }} variant="h3" >{lang_id === 'fr' ? "recherche par prix" : "search by price"}</Typography>

            <Box display="flex"
              justifyContent="center"
              alignItems="center"
            >
              <Box sx={{ width: '80%' }} >
                <FilterSlider
                  getAriaLabel={() => 'PriceRange'}
                  value={priceRangeValue}
                  onChange={handleChange}
                  valueLabelDisplay="on"
                  track="normal"
                  disableSwap
                  getAriaValueText={valuetext}
                  min={min_price}
                  max={max_price}
                  
                  step={100}
                 
                />
              </Box>
            </Box>

            <Stack direction="row" justifyContent="space-evenly" alignItems="center" width="105%">
              <FormControl variant="standard" sx={{ m: 1, mt: 3, ml:3, width: "25ch" }}>
                <CssTextField
                  label="min"
                  variant="standard"
                  InputLabelProps={{ shrink: true }}
                  value={priceRangeValue[0]}
                  sx={{width:"80%"}}
                  onChange={(e) => {
                    setPriceRangeValue([!isNaN(Number(e.target.value)) ? e.target.value : 0, priceRangeValue[1]]);
                  }}
                />
          
              </FormControl>
        
              <FormControl variant="standard" sx={{ m: 1, mt: 3, ml:3, width: "25ch" }}>
                <CssTextField
                  label="max"
                  variant="standard"
                  InputLabelProps={{ shrink: true }}
                  value={priceRangeValue[1]}
                  sx={{width:"80%"}}
                  onChange={(e) => {
                    setPriceRangeValue([priceRangeValue[0], !isNaN(Number(e.target.value)) ? e.target.value : ""]);
                  }}
                />
              </FormControl>
            </Stack>

          <Stack direction="row" justifyContent="space-evenly" alignItems="center">
            <Button variant="contained" sx={{ textTransform:'lowercase',fontSize:'16px',fontFamily:"verdana",lineHeight:"24px", width: "90%", boxShadow:"none", backgroundColor: 'white', border: 1,borderRadius:"8px",borderColor: 'black', "&:hover": { backgroundColor: "#faf4b4", boxShadow:"none" } }} onClick={handleClick}>search</Button>
          </Stack>
          </Stack>


        </Paper>


      </Stack>
    </>
  );
}